import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=0f8885f0&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports